import React, { Suspense, lazy } from 'react';
import { Hero, Stats } from './components/SectionsPart1';
import { MetaPixel } from './components/MetaPixel';
// Below-the-fold sections are code-split so the initial bundle stays small
// and the hero paints as fast as possible.
const TestimonialsInitial = lazy(() => import('./components/SectionsPart1').then(m => ({
  default: m.TestimonialsInitial
})));
const Problem = lazy(() => import('./components/SectionsPart1').then(m => ({
  default: m.Problem
})));
const ProductPresentation = lazy(() => import('./components/SectionsPart1').then(m => ({
  default: m.ProductPresentation
})));
const WhatYouGet = lazy(() => import('./components/SectionsPart1').then(m => ({
  default: m.WhatYouGet
})));
const WhatEachTomeIncludes = lazy(() => import('./components/SectionsPart1').then(m => ({
  default: m.WhatEachTomeIncludes
})));
const Bonuses = lazy(() => import('./components/SectionsPart1').then(m => ({
  default: m.Bonuses
})));
const UrgencyCountdown = lazy(() => import('./components/SectionsPart2').then(m => ({
  default: m.UrgencyCountdown
})));
const Pricing = lazy(() => import('./components/SectionsPart2').then(m => ({
  default: m.Pricing
})));
const MegapackDetail = lazy(() => import('./components/SectionsPart2').then(m => ({
  default: m.MegapackDetail
})));
const TestimonialsExtended = lazy(() => import('./components/SectionsPart2').then(m => ({
  default: m.TestimonialsExtended
})));
const Guarantee = lazy(() => import('./components/SectionsPart2').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/SectionsPart2').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/SectionsPart2').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/SectionsPart2').then(m => ({
  default: m.Footer
})));
const PurchaseNotification = lazy(() => import('./components/PurchaseNotification').then(m => ({
  default: m.PurchaseNotification
})));
export function App() {
  return <div className="font-sans text-purple-deep bg-cream overflow-x-hidden selection:bg-coral selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <Stats data-id="element-3" />
      <Suspense fallback={<div className="min-h-[40vh] bg-cream" data-id="element-5" />} data-id="element-4">
        <TestimonialsInitial data-id="element-6" />
        <Problem data-id="element-7" />
        <ProductPresentation data-id="element-8" />
        <WhatYouGet data-id="element-9" />
        <WhatEachTomeIncludes data-id="element-10" />
        <Bonuses data-id="element-11" />
        <UrgencyCountdown data-id="element-12" />
        <Pricing data-id="element-13" />
        <MegapackDetail data-id="element-14" />
        <TestimonialsExtended data-id="element-15" />
        <Guarantee data-id="element-16" />
        <FAQ data-id="element-17" />
        <FinalCTA data-id="element-18" />
        <Footer data-id="element-19" />
        <PurchaseNotification data-id="element-20" />
      </Suspense>
    </div>;
}